module.exports = __webpack_public_path__ + "img/failAudit.cb475d1b.png";